"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalWrapper = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Portal_1 = require("./Portal");
const styles_1 = require("./styles");
const ModalWrapper = props => {
  const {
    children,
    backgroundColor,
    parentRef,
    modalId,
    opacity,
    isRemovable = true
  } = props;
  return isRemovable ? (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, {
    children: [(0, jsx_runtime_1.jsx)(styles_1.GlobalStyle, {}), (0, jsx_runtime_1.jsxs)(Portal_1.Portal, {
      parentRef: parentRef,
      modalId: modalId,
      children: [(0, jsx_runtime_1.jsx)(styles_1.StyledModalBackdrop, {
        backgroundColor: backgroundColor,
        opacity: opacity
      }), children]
    })]
  }) : (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, {
    children: [(0, jsx_runtime_1.jsx)(styles_1.GlobalStyle, {}), (0, jsx_runtime_1.jsx)(styles_1.StyledModalBackdrop, {
      backgroundColor: backgroundColor,
      opacity: opacity
    })]
  });
};
exports.ModalWrapper = ModalWrapper;